import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

import {
  RIGHTS_BRANCHES,
  RIGHTS_IS_CREATE,
  RIGHTS_IS_ON,
  TABLET,
} from '@app/constants';
import { useAccessRights, useWindowSize } from '@app/hooks';

export const BranchesPageHeader = () => {
  const { hasUserRightForModuleView } = useAccessRights(
    RIGHTS_BRANCHES,
    RIGHTS_IS_ON
  );
  const { hasUserRight } = useAccessRights(RIGHTS_BRANCHES, RIGHTS_IS_CREATE);
  const { innerWidth } = useWindowSize();

  const label = innerWidth < TABLET ? '' : 'Добавить филиал';

  if (!hasUserRightForModuleView || !hasUserRight) {
    return <></>;
  }

  return (
    <Link to="/branches/add">
      <Button type="primary" icon={<PlusOutlined />} data-testid="add-branch">
        {label}
      </Button>
    </Link>
  );
};
